import { NumbersSection } from './NumbersSection/Numbers.section';
import { TeamsSection } from './TeamsSection/Teams.section';

import { ThemeProvider } from '@aircall/tractor-v2';
import { DetailPage } from '@components/DetailPage/DetailPage';
import { Loading, useGraphQuery } from '@dashboard/library';
import {
  GetUserAssociatedLinesQuery,
  GetUserAssociatedLinesQueryVariables,
} from '@generated/GetUserAssociatedLinesQuery';
import { GET_USER_ASSOCIATED_LINES_QUERY } from '@graphql/queries/GetUserAssociatedLinesQuery';
import { UserProfileTabProps } from '@pages/user-profile/UserProfile.decl';

export function UserProfileNumbersTeamsTab({ user }: UserProfileTabProps) {
  const { loading, data, fetchMore } = useGraphQuery<
    GetUserAssociatedLinesQuery,
    GetUserAssociatedLinesQueryVariables
  >(GET_USER_ASSOCIATED_LINES_QUERY, {
    variables: { agentID: user.ID, token: '1' },
    fetchPolicy: 'cache-and-network',
  });

  if (loading || !data) {
    return (
      <ThemeProvider>
        <Loading data-test='number-integration-list-loader' />
      </ThemeProvider>
    );
  }

  return (
    <DetailPage data-test='user-profile-numbers-teams'>
      <NumbersSection
        user={user}
        associatedLines={data.getAgentV2.associatedLines!}
        fetchMore={fetchMore}
      />
      <TeamsSection user={user} />
    </DetailPage>
  );
}
